import { SearchOutlined } from '@ant-design/icons';
import { Flex, Input, theme } from 'antd';
import { type ReactNode, useEffect, useState } from 'react';

export interface MealItemsFiltersProps {
  onChange?: (filters: FiltersState) => void;
  initialFilters?: FiltersState;
}

interface FiltersState {
  query?: string;
}

const MealItemsFilter = (props: MealItemsFiltersProps): ReactNode => {
  const { initialFilters, onChange } = props;
  const [filters, setFilter] = useState<FiltersState>(initialFilters ?? {});
  const { token } = theme.useToken();

  useEffect(() => {
    onChange?.(filters);
  }, [filters]);

  return (
    <Flex gap={token.paddingXS} flex={1} wrap="wrap">
      <Input
        allowClear
        value={filters?.query}
        placeholder="Search"
        prefix={<SearchOutlined />}
        onChange={(e) => {
          setFilter((prev) => ({
            ...prev,
            query: e.target?.value || undefined,
          }));
        }}
        style={{ maxWidth: 300, marginInlineEnd: token.marginMD }}
      />
    </Flex>
  );
};

MealItemsFilter.defaultProps = {
  onChange: () => {},
  initialFilters: {},
};

export default MealItemsFilter;
